__turbopack_context__.v({
  "holidayIcon": "IconCategoryMap-module-scss-module__lkHF3q__holidayIcon",
  "iconFill": "IconCategoryMap-module-scss-module__lkHF3q__iconFill",
  "iconSize": "IconCategoryMap-module-scss-module__lkHF3q__iconSize",
  "nyeIcon": "IconCategoryMap-module-scss-module__lkHF3q__nyeIcon",
  "strokeWidth": "IconCategoryMap-module-scss-module__lkHF3q__strokeWidth",
});
